module.exports = __webpack_public_path__ + "img/nancomcy-big-footer.af7d5dc.svg";